export enum OperationEnum {
  // String Operations
  InList = 'in_list',
  StartsWith = 'starts_with',
  EndsWith = 'ends_with',
  Contains = 'contains',
  Matches = 'matches',

  // Numeric Operations
  Equal = 'equal',
  GreaterThan = 'greater_than',
  GreaterThanEqual = 'greater_than_equal',
  LesserThan = 'lower_than',
  LesserThanEqual = 'lower_than_equal',
  BetweenNumeric = 'between_numeric',

  // Boolean Operations
  Is = 'is',

  // Date Operations
  On = 'on',
  BetweenDate = 'between_date',
  OnOrAfter = 'on_or_after',
  OnOrBefore = 'on_or_before',
}
